// Shared layout for /start/* pages. Centered card, back link, and a
// step counter slot. Wizards live inside this shell so they look
// consistent.

import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";

interface Props {
  title: string;
  subtitle?: string;
  step?: { current: number; total: number };
  children: ReactNode;
  rightSlot?: ReactNode;
}

export default function StartShell({ title, subtitle, step, children, rightSlot }: Props) {
  return (
    <div className="start-shell">
      <div className="start-shell-top">
        <Link to="/dashboard">
          <ArrowLeft size={14} /> Back to ProtoPal
        </Link>
        {step && (
          <span className="start-step-count">
            Step {step.current} of {step.total}
          </span>
        )}
      </div>
      <div className="start-shell-heading">
        <div className="studio-eyebrow">Create a website</div>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <div className="card start-shell-card">
        {step && <div className="start-progress" aria-hidden><span style={{ width: `${(step.current / step.total) * 100}%` }} /></div>}
        {children}
      </div>
      {rightSlot}
    </div>
  );
}
